import { Maybe } from '@/utils/types'
import { ContentInteraction } from '../useContentInteraction'

type Surface = 'player'
type ItemType = 'ContentMovie' | 'ContentSpecial' | 'ContentSeries'

/**
 * Interaction builder for end-of-asset recommendation titles
 * Used for tracking user interactions with recommended content shown at the end of a video
 */
export class EndOfAssetRailItemInteraction extends ContentInteraction<Surface> {
  constructor(item: { id: string; __typename: Maybe<ItemType>; attribution: unknown }) {
    super(item)
  }
}
